import React from 'react';
import { Sparkles } from 'lucide-react';

const TA = 'w-full bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-white text-xs';
const LISTS = [['normas', 'Normas aplicables'], ['riesgos', 'Riesgos'], ['proximos_pasos', 'Próximos pasos'], ['documentos_faltantes', 'Documentos que conviene reunir']];
const APRECIA = [['favorable', 'Favorable'], ['incierta', 'Incierta'], ['desfavorable', 'Desfavorable']];

// AI strategy draft from the uploaded documents; the lawyer edits and approves it before it is saved in the case
export const IntakeStrategyEditor = ({ value, onChange, approved, onApprove }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const lineas = value.lineas || [];
  return (
    <div data-testid="intake-strategy-editor" className="space-y-2 rounded-xl border border-amber-500/30 bg-amber-500/5 p-3">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-amber-200"><Sparkles className="h-4 w-4" />Estrategia propuesta por IA (borrador editable)</p>
      <textarea data-testid="intake-strategy-resumen" rows={3} value={value.resumen || ''} onChange={(e) => set('resumen', e.target.value)} placeholder="Diagnóstico" className={TA} />
      <textarea data-testid="intake-strategy-objetivo" rows={2} value={value.objetivo || ''} onChange={(e) => set('objetivo', e.target.value)} placeholder="Objetivo" className={TA} />
      <div className="flex items-center gap-2 text-xs text-slate-300">
        Apreciación cualitativa:
        <select data-testid="intake-strategy-apreciacion" value={value.apreciacion || 'incierta'} onChange={(e) => set('apreciacion', e.target.value)} className="bg-slate-800 border border-slate-600 rounded-lg px-2 py-1 text-xs text-white">
          {APRECIA.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </div>
      <textarea data-testid="intake-strategy-fundamento" rows={2} value={value.fundamento_apreciacion || ''} onChange={(e) => set('fundamento_apreciacion', e.target.value)} placeholder="Fundamento de la apreciación" className={TA} />
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Líneas de acción</p>
      {lineas.map((l, i) => (
        <div key={i} className="space-y-1">
          <input data-testid={`intake-strategy-linea-titulo-${i}`} value={l.titulo || ''} onChange={(e) => set('lineas', lineas.map((x, j) => (j === i ? { ...x, titulo: e.target.value } : x)))} className={TA} />
          <textarea data-testid={`intake-strategy-linea-detalle-${i}`} rows={2} value={l.detalle || ''} onChange={(e) => set('lineas', lineas.map((x, j) => (j === i ? { ...x, detalle: e.target.value } : x)))} className={TA} />
        </div>
      ))}
      {LISTS.map(([k, label]) => (
        <div key={k}>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label} (una por línea)</p>
          <textarea data-testid={`intake-strategy-${k}`} rows={3} value={(value[k] || []).join('\n')} onChange={(e) => set(k, e.target.value.split('\n'))} className={TA} />
        </div>
      ))}
      <label className="flex items-start gap-2 text-xs text-slate-200">
        <input data-testid="intake-strategy-approve" type="checkbox" checked={approved} onChange={(e) => onApprove(e.target.checked)} className="mt-0.5 accent-amber-500" />
        Revisé la estrategia y la guardo en el caso como borrador aprobado por mí.
      </label>
    </div>
  );
};

export const cleanStrategy = (s) => ({ ...s, ...Object.fromEntries(LISTS.map(([k]) => [k, (s[k] || []).map((x) => x.trim()).filter(Boolean)])) });
